(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pm-sim-js"] && !Shopify.designMode) return;
  try {
    (() => {
    const $ = (s, q) => s.querySelector(q);

    // Motor común de los juegos de pasos: estado 0 = inicio, estado k = hecho el paso k. Un solo botón que avanza y, al final, vuelve a empezar.
    const G = {
      orejeras: { intro: 'Tu perro, tranquilo en casa. Toca el botón verde.', steps: [['1 · Toca aquí: que suenen los petardos 🎆', 'Petardos y tormentas: muchos perros lo pasan mal.'], ['2 · Toca aquí: ponerle las orejeras', 'Con las orejeras le llega menos ruido y se le ve más tranquilo.']] },
      chaleco: { intro: 'Un perro y su chaleco. Toca el botón verde.', steps: [['1 · Toca aquí: medirle el pecho 📏', 'Por la parte más ancha y elige talla en la tabla.'], ['2 · Toca aquí: ajustar los velcros', 'Ceñido pero cómodo: que te quepan dos dedos.'], ['3 · Toca aquí: subir la capucha 🎆', 'Le cubre las orejas cuando hay tormenta o petardos.']] },
      rodillo: { intro: 'Un sofá lleno de pelo. Toca el botón verde.', steps: [['1 · Toca aquí: pasarlo adelante y atrás', 'Movimientos cortos sobre el sofá, la cama o la ropa. El pelo se queda atrapado.'], ['2 · Toca aquí: abrir la tapa', 'Todo el pelo recogido, junto en el depósito.'], ['3 · Toca aquí: vaciarlo y repetir 🗑️', 'A la basura en dos segundos. Sin papel, sin recambios, sin pilas.']] },
      barro: { intro: 'Pata llena de barro tras el paseo. Toca el botón verde.', steps: [['1 · Toca aquí: echar un poco de agua 💧', 'Un poco de agua en el vaso.'], ['2 · Toca aquí: meter la pata y girar 🐾', 'Las cerdas de silicona blanda limpian entre los dedos y el barro se queda en el vaso.'], ['3 · Toca aquí: sacarla y secarla 🧻', 'Pata limpia: el barro se queda en el vaso, no en tu suelo.']] },
      olfato: { intro: 'Una alfombrilla con pliegues y unos premios. Toca el botón verde.', steps: [['1 · Toca aquí: esconder los premios 🦴', 'Pienso o premios pequeños entre los pliegues de tela.'], ['2 · Toca aquí: que busque con la nariz 🐶', 'Con la nariz y a su ritmo, siempre contigo cerca.'], ['3 · Toca aquí: subir la dificultad ⬆️', 'Escóndelo más cuando le pille el truco.']] },
      ventana: { intro: 'Una ventana y una hamaca. Toca el botón verde.', steps: [['1 · Toca aquí: limpiar el cristal 🧽', 'Cristal liso, limpio y seco para que las ventosas agarren bien.'], ['2 · Toca aquí: pegar las ventosas 💪', 'Cada ventosa con fuerza. Comprueba que aguanta antes de subirle.'], ['3 · Toca aquí: invitarle a subir 🐱', 'Con su manta o unos premios. El resto lo pone el sol.']] },
      lluvia: { intro: 'Día de paseo. Toca el botón verde.', steps: [['1 · Toca aquí: que llueva 🌧️', 'Sin chubasquero, vuelta a casa con el pelo mojado.'], ['2 · Toca aquí: ponerle el chubasquero', 'Impermeable y con capucha: la lluvia resbala.'], ['3 · Toca aquí: paseo de noche 🌙', 'Las tiras reflectantes ayudan a que os vean al anochecer.']] },
      manos: { intro: 'Paseo con tu perro. Toca el botón verde.', steps: [['1 · Toca aquí: engancharla al collar 🔗', 'El mosquetón, al collar o al arnés.'], ['2 · Toca aquí: cruzarla en bandolera 🎒', 'Cruzada sobre el pecho: manos libres para el café o el móvil.'], ['3 · Toca aquí: limpiarla con un paño 🧽', 'Es impermeable: un paño y como nueva.']] },
      cepillo: { intro: 'Pelaje con nudos y pelo suelto. Toca el botón verde.', steps: [['1 · Toca aquí: cara de desenredar', 'Deshace los nudos con suavidad. Púas redondeadas.'], ['2 · Toca aquí: cara de pelo muerto', 'Retira el pelo suelto antes de que acabe en el sofá. Pensado para pelo medio y largo.']] },
      guante: { intro: 'Un cojín lleno de pelo. Toca el botón verde.', steps: [['1 · Toca aquí: ponerte el guante 🧤', 'Se ajusta a la mano como un guante normal.'], ['2 · Toca aquí: pasar la mano por el cojín ✋', 'La malla atrapa el pelo suelto del cojín, la manta o la ropa.'], ['3 · Toca aquí: sacudirlo 🔄', 'Unas sacudidas o un poco de agua y queda listo.']] },
      lamer: { intro: 'Una alfombrilla limpia y su espátula. Toca el botón verde.', steps: [['1 · Toca aquí: untar con la espátula 🥄', 'Yogur natural, paté o su comida húmeda, con la espátula incluida.'], ['2 · Toca aquí: que lama 🐶', 'Lamer suele relajarles y los entretiene un buen rato. Cada peludo es distinto.'], ['3 · Toca aquí: lavarla 🫧', 'Con agua y jabón. Silicona flexible.']] },
      mochila: { intro: 'Una bolsa de premios vacía. Toca el botón verde.', steps: [['1 · Toca aquí: llenarla de premios 🦴', 'Compartimento principal con cierre de cordón.'], ['2 · Toca aquí: abrirla con una mano ✋', 'Das el premio en el momento justo.'], ['3 · Toca aquí: cerrarla tirando del cordón', 'No se sale nada. En bandolera o a la cintura.']] },
      calor: { intro: 'Una manta y un sofá. Toca el botón verde.', steps: [['1 · Toca aquí: ponerla en su sitio', 'Un rincón del sofá o su cama. La base es antideslizante.'], ['2 · Toca aquí: que el gato la estrene 🐱', 'Se tumba, amasa la felpa y la manta le devuelve su propio calor.'], ['3 · Toca aquí: a dormir calentito 💤', 'Sin cables, sin enchufe y sin pilas.']] },
      bolas: { intro: 'Ropa con pelo de tu peludo. Toca el botón verde.', steps: [['1 · Toca aquí: meter la bola con la ropa 🧺', 'La bola va con la ropa de siempre.'], ['2 · Toca aquí: poner la lavadora ▶️', 'Mientras gira, la bola ayuda a recoger el pelo suelto.'], ['3 · Toca aquí: sacar y vaciar la bola ✋', 'Quita el pelo de la bola y queda lista para la siguiente colada.']] },
      derrame: { intro: 'Un sofá y una manta. Toca el botón verde.', steps: [['1 · Toca aquí: poner la manta en el sofá', 'Impermeable y reversible, para perros y gatos.'], ['2 · Toca aquí: ¡se vuelca el agua! 💦', 'El líquido se queda en la manta y no llega al sofá.'], ['3 · Toca aquí: meterla en la lavadora 🫧', 'Lavable a máquina.']] },
      protector: { intro: 'El brazo del sofá, donde más rasca. Toca el botón verde.', steps: [['1 · Toca aquí: medir la zona 📏', 'Brazo, esquina o respaldo: elige 30 x 100 o 60 x 100 cm.'], ['2 · Toca aquí: colocarlo', 'Cubre la zona donde más rasca y alísalo bien.'], ['3 · Toca aquí: que rasque tranquilo 🐱', 'Las uñas se las lleva el protector, no el tapizado.']] }
    };
    document.querySelectorAll('[data-g]:not([data-b])').forEach((s) => {
      s.dataset.b = '1';
      const c = G[s.dataset.pmSim];
      if (!c) return;
      const n = c.steps.length;
      const go = $(s, '[data-go]');
      let k = 0;
      const draw = () => {
        s.dataset.state = k;
        $(s, '[data-msg]').textContent = k ? c.steps[k - 1][1] : c.intro;
        $(s, '[data-step]').textContent = k < n ? 'Paso ' + (k + 1) + ' de ' + n : '¡Listo! Puedes repetirlo';
        go.textContent = k < n ? c.steps[k][0] : 'Volver a empezar ↺';
      };
      go.addEventListener('click', () => { k = k < n ? k + 1 : 0; draw(); });
      $(s, '[data-reset]').addEventListener('click', () => { k = 0; draw(); });
      draw();
    });

    // Agua: servir → que beba → otra vez. El perro y el cuenco siempre se ven; el perro baja la cabeza a beber.
    document.querySelectorAll('[data-pm-sim="agua"]:not([data-b])').forEach((s) => {
      s.dataset.b = '1';
      const MAX = 285; const SIP = 57;
      let ml = MAX; let bowl = 0; let drunk = 0;
      const go = $(s, '[data-go]');
      const draw = (txt) => {
        $(s, '[data-ml]').textContent = ml;
        $(s, '[data-level]').style.transform = 'scaleY(' + (ml / MAX) + ')';
        $(s, '[data-water]').style.transform = 'scaleY(' + (bowl ? 1 : 0) + ')';
        $(s, '[data-dog]').style.transform = 'translateY(' + (bowl ? 30 : 0) + 'px)';
        $(s, '[data-msg]').textContent = txt;
        $(s, '[data-step]').textContent = bowl ? 'Paso 2 de 2' : (drunk ? '¡Listo! Puedes repetirlo' : 'Paso 1 de 2');
        go.disabled = !bowl && ml < SIP;
        go.textContent = bowl ? '2 · Toca aquí: que beba 🐶' : (ml < SIP ? 'Botella vacía: toca «Volver a empezar»' : (drunk ? 'Otra vez: servir agua 💧' : '1 · Toca aquí: servir agua 💧'));
      };
      go.addEventListener('click', () => {
        if (bowl) {
          drunk += bowl; bowl = 0;
          draw(ml >= SIP ? '¡Ha bebido! Lleva ' + drunk + ' ml en total. Quedan ' + ml + ' ml en la botella.' : '¡Ha bebido! Lleva ' + drunk + ' ml: los 285 ml dan para varias paradas del paseo.');
        } else {
          ml -= SIP; bowl = SIP;
          draw('Has servido ' + SIP + ' ml en el cuenco. Ahora toca el botón para que beba.');
        }
      });
      $(s, '[data-reset]').addEventListener('click', () => { ml = MAX; bowl = 0; drunk = 0; draw('Botella llena. Toca el botón verde.'); });
      draw('Botella llena. Toca el botón verde.');
    });

    // Dispensador: rollo dentro → a la correa → sacar bolsa (una cada vez). Todo se ve siempre; solo se mueve.
    document.querySelectorAll('[data-pm-sim="dispensador"]:not([data-b])').forEach((s) => {
      s.dataset.b = '1';
      const LABEL = ['1 · Toca aquí: meter el rollo 🧻', '2 · Toca aquí: engancharlo a la correa 🔗', '3 · Toca aquí: sacar una bolsa 🛍️'];
      const TXT = [
        'Aquí tienes el dispensador y un rollo. Toca el botón verde.',
        'Rollo dentro. Ahora, a la correa.',
        'Enganchado a la correa: va contigo sin ocupar bolsillos. Ahora saca una bolsa.',
        'Las bolsas salen de una en una por la ventanita.'
      ];
      const go = $(s, '[data-go]');
      const bag = $(s, '[data-bag]');
      let step = 0; let out = 0;
      const pull = () => {
        bag.style.transition = 'none';
        bag.style.transform = 'scaleY(0)';
        bag.getBoundingClientRect();
        bag.style.transition = 'transform 0.5s';
        bag.style.transform = 'scaleY(1)';
      };
      const draw = () => {
        $(s, '[data-roll]').style.transform = step >= 1 ? 'translate(130px, 92px) scale(0.8)' : 'translate(48px, 150px)';
        $(s, '[data-disp]').style.transform = 'translateY(' + (step >= 2 ? 0 : 40) + 'px)';
        $(s, '[data-count]').textContent = out;
        $(s, '[data-step]').textContent = step >= 3 ? '¡Listo para pasear!' : 'Paso ' + (step + 1) + ' de 3';
        $(s, '[data-msg]').textContent = TXT[step];
        go.textContent = step < 3 ? LABEL[step] : 'Sacar otra bolsa 🛍️';
      };
      go.addEventListener('click', () => {
        if (step < 2) step += 1; else { step = 3; out += 1; pull(); }
        draw();
      });
      $(s, '[data-reset]').addEventListener('click', () => { step = 0; out = 0; bag.style.transform = 'scaleY(0)'; draw(); });
      draw();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-interactive-simulator-2"] && !Shopify.designMode) return;
  try {
    (() => {
    // Ventana segura
    document.querySelectorAll('[data-pm-sim="ventana"]:not([data-b])').forEach((s) => {
      s.dataset.b = '1';
      const STEPS = ['Cristal limpio y seco: pulsa la ventosa 1.', 'Presiona fuerte la ventosa 2.', 'Ahora la 3. Espera unos minutos antes de soltar el peso.', 'Y la 4.', 'Fijación completa. Comprueba con la mano que aguanta antes de dejar que tu gato suba.'];
      const cups = [...s.querySelectorAll('[data-ven]')];
      const msg = s.querySelector('[data-vmsg]');
      const w = s.querySelector('[data-w]');
      const cat = s.querySelector('[data-cat]');
      const sag = s.querySelector('[data-sag]');
      const wmsg = s.querySelector('[data-wmsg]');
      const draw = () => {
        const n = cups.filter((c) => c.getAttribute('aria-pressed') === 'true').length;
        const ok = n === 4;
        s.classList.toggle('is-fixed', ok);
        msg.textContent = STEPS[n];
        w.disabled = !ok;
        wmsg.hidden = !ok;
        if (ok) weight();
      };
      const weight = () => {
        const kg = Number(w.value);
        s.querySelector('[data-wval]').textContent = kg + ' kg';
        cat.style.transform = 'scale(' + (0.8 + kg * 0.04) + ')';
        sag.setAttribute('d', 'M70 150 Q150 ' + (170 + kg * 1.6) + ' 230 150 L230 126 L70 126 Z');
        wmsg.textContent = kg <= 8
          ? 'Bien colocada aguanta a un gato adulto. Revisa las ventosas cada semana, sobre todo en invierno.'
          : 'Con un gato muy grande o muy saltarín: ponla a poca altura, sobre un mueble o el alféizar, y revisa las ventosas cada semana.';
      };
      cups.forEach((c, i) => c.addEventListener('click', () => {
        const done = cups.filter((x) => x.getAttribute('aria-pressed') === 'true').length;
        if (i === done) { c.setAttribute('aria-pressed', 'true'); draw(); }
      }));
      w.addEventListener('input', weight);
      s.querySelector('[data-reset]').addEventListener('click', () => { cups.forEach((c) => c.setAttribute('aria-pressed', 'false')); w.value = 5; draw(); });
      draw();
    });

    // Lluvia y noche
    document.querySelectorAll('[data-pm-sim="lluvia"]:not([data-b])').forEach((s) => {
      s.dataset.b = '1';
      const rain = s.querySelector('[data-rain]');
      const night = s.querySelector('[data-night]');
      const msg = s.querySelector('[data-rmsg]');
      const draw = () => {
        const r = rain.getAttribute('aria-pressed') === 'true';
        const n = night.getAttribute('aria-pressed') === 'true';
        s.classList.toggle('is-rain', r);
        s.classList.toggle('is-night', n);
        msg.textContent = r && n ? 'Lluvia de noche: tejido impermeable y tiras reflectantes.'
          : r ? 'El tejido es impermeable: la lluvia resbala por encima.'
          : n ? 'Las tiras reflectantes devuelven la luz para que os vean con poca luz.'
          : 'Elige una prueba.';
      };
      [rain, night].forEach((b) => b.addEventListener('click', () => { b.setAttribute('aria-pressed', String(b.getAttribute('aria-pressed') !== 'true')); draw(); }));
    });

    // Manos libres
    document.querySelectorAll('[data-pm-sim="manos"]:not([data-b])').forEach((s) => {
      s.dataset.b = '1';
      const cmp = s.querySelector('[data-cmp]');
      s.querySelector('[data-c]').addEventListener('input', (e) => { cmp.style.setProperty('--p', e.target.value + '%'); });
    });

    // El calor vuelve a él
    document.querySelectorAll('[data-pm-sim="calor"]:not([data-b])').forEach((s) => {
      s.dataset.b = '1';
      const t = s.querySelector('[data-t]');
      const btn = s.querySelector('[data-on]');
      const msg = s.querySelector('[data-cmsg]');
      const draw = () => {
        const deg = Number(t.value);
        const on = btn.getAttribute('aria-pressed') === 'true';
        s.querySelector('[data-tval]').textContent = deg + ' °C';
        s.classList.toggle('is-cold', deg <= 17 && !on);
        s.classList.toggle('is-on', on);
        btn.textContent = on ? 'Capa térmica activada' : 'Activar capa térmica Patamora';
        msg.textContent = on ? '0 W de electricidad · 100 % su propio calor'
          : deg <= 17 ? 'A ' + deg + ' °C se encoge y tiembla: la casa se ha quedado fría.'
          : 'A ' + deg + ' °C está a gusto. Baja la temperatura para ver qué pasa.';
      };
      t.addEventListener('input', draw);
      btn.addEventListener('click', () => { btn.setAttribute('aria-pressed', String(btn.getAttribute('aria-pressed') !== 'true')); draw(); });
      draw();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-interactive-simulator-3"] && !Shopify.designMode) return;
  try {
    (() => {
    const buy = (e) => {
      const b = e.target.closest('[data-buy]');
      if (!b) return;
      e.preventDefault();
      (document.querySelector('[data-pm-buy], product-form, .product-form, .product-details, main form[action*="/cart/add"]') || document.body).scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    // Arrastrar sobre el elemento = una pasada cada 60 px recorridos
    const dragPass = (el, pass) => {
      let y0 = null; let last = 0; let acc = 0;
      el.addEventListener('pointerdown', (e) => { el.setPointerCapture(e.pointerId); y0 = 1; last = e.clientX + e.clientY; acc = 0; });
      el.addEventListener('pointermove', (e) => {
        if (y0 === null) return;
        const p = e.clientX + e.clientY;
        acc += Math.abs(p - last); last = p;
        if (acc >= 60) { acc = 0; pass(); }
      });
      ['pointerup', 'pointercancel'].forEach((ev) => el.addEventListener(ev, () => { y0 = null; }));
    };
    const $ = (s, q) => s.querySelector(q);

    // 7. Agua
    document.querySelectorAll('[data-pm-sim="agua"]:not([data-b])').forEach((s) => {
      s.dataset.b = '1';
      const MAX = 285; const SIP = 57;
      let ml = MAX; let bowl = 0; let drunk = 0;
      const draw = (txt) => {
        $(s, '[data-ml]').textContent = ml;
        $(s, '[data-level]').style.transform = 'scaleY(' + (ml / MAX) + ')';
        $(s, '[data-bowl]').style.opacity = bowl ? 1 : 0;
        $(s, '[data-dog]').style.opacity = bowl ? 1 : 0;
        $(s, '[data-pour]').disabled = bowl > 0 || ml < SIP;
        $(s, '[data-drink]').disabled = !bowl;
        $(s, '[data-msg]').textContent = txt;
      };
      $(s, '[data-pour]').addEventListener('click', () => { ml -= SIP; bowl = SIP; draw('Cuenco servido: ' + SIP + ' ml. Que beba.'); });
      $(s, '[data-drink]').addEventListener('click', () => { drunk += bowl; bowl = 0; draw(ml >= SIP ? 'Ha bebido ' + drunk + ' ml en total. Sirve otro poco cuando quiera más.' : 'Ha bebido ' + drunk + ' ml: los 285 ml dan para varias paradas del paseo.'); });
      $(s, '[data-reset]').addEventListener('click', () => { ml = MAX; bowl = 0; drunk = 0; draw('Botella llena. Pulsa «Servir agua».'); });
      draw('Botella llena. Pulsa «Servir agua».');
    });

    // 8a. Cepillo: cara 1 = 3 nudos, cara 2 = 6 pelos muertos
    document.querySelectorAll('[data-pm-sim="cepillo"]:not([data-b])').forEach((s) => {
      s.dataset.b = '1';
      const knots = [...s.querySelectorAll('[data-knot]')];
      const loose = [...s.querySelectorAll('[data-loose]')];
      const sides = [...s.querySelectorAll('[data-side]')];
      const msg = $(s, '[data-msg]');
      let nk = 3; let nl = 6; let side = 1; let hint = '';
      const draw = () => {
        knots.forEach((k, i) => { k.style.opacity = i < nk ? 1 : 0; });
        loose.forEach((l, i) => { l.style.opacity = i < nl ? 1 : 0; });
        sides.forEach((b) => b.setAttribute('aria-pressed', String(Number(b.dataset.side) === side)));
        $(s, '[data-knots]').textContent = nk;
        $(s, '[data-loosen]').textContent = nl;
        $(s, '[data-done]').hidden = !(nk === 0 && nl === 0);
        const note = s.querySelector('.pm-sim__hint');
        if (note) note.remove();
        if (hint) { const p = document.createElement('span'); p.className = 'pm-sim__hint'; p.textContent = ' ' + hint; msg.append(p); }
      };
      const pass = () => {
        hint = '';
        if (side === 1) { if (nk) nk -= 1; else hint = 'Los nudos ya están: prueba la otra cara.'; }
        else if (nk) hint = 'Primero deshaz los nudos con la otra cara.';
        else if (nl) nl = Math.max(0, nl - 2);
        draw();
      };
      sides.forEach((b) => b.addEventListener('click', () => { side = Number(b.dataset.side); hint = ''; draw(); }));
      $(s, '[data-pass]').addEventListener('click', pass);
      dragPass($(s, '[data-coat]'), pass);
      $(s, '[data-reset]').addEventListener('click', () => { nk = 3; nl = 6; side = 1; hint = ''; draw(); });
      draw();
    });

    // 8b. Guante: 4 pasadas = 100 %, luego se sacude
    document.querySelectorAll('[data-pm-sim="guante"]:not([data-b])').forEach((s) => {
      s.dataset.b = '1';
      const hairs = [...s.querySelectorAll('[data-hair]')];
      let n = 0;
      const draw = () => {
        const p = Math.min(100, n * 25);
        $(s, '[data-pct]').textContent = p + '%';
        $(s, '[data-bar]').style.width = p + '%';
        hairs.forEach((h, i) => { h.style.opacity = i / hairs.length < 1 - p / 100 ? 1 : 0; });
        $(s, '[data-shake]').disabled = p < 100;
        $(s, '[data-pass]').disabled = p >= 100;
        $(s, '[data-done]').hidden = !(n === 0 && s.dataset.shaken);
      };
      const pass = () => { if (n < 4) { n += 1; draw(); } };
      $(s, '[data-pass]').addEventListener('click', pass);
      dragPass($(s, '[data-coat]'), pass);
      $(s, '[data-shake]').addEventListener('click', () => { n = 0; s.dataset.shaken = '1'; draw(); });
      $(s, '[data-reset]').addEventListener('click', () => { n = 0; delete s.dataset.shaken; draw(); });
      draw();
    });

    // 9. Lamer: ingrediente → untar (3 toques) → congelar (opcional)
    document.querySelectorAll('[data-pm-sim="lamer"]:not([data-b])').forEach((s) => {
      s.dataset.b = '1';
      const cells = [...s.querySelectorAll('[data-cell]')];
      const ings = [...s.querySelectorAll('[data-ing]')];
      const msg = $(s, '[data-msg]');
      let color = ''; let spread = 0; let frozen = false;
      const draw = () => {
        cells.forEach((c, i) => { c.setAttribute('fill', color && i < spread ? color : '#1E8A84'); });
        $(s, '[data-frost]').style.opacity = frozen ? 0.55 : 0;
        $(s, '[data-spread]').disabled = !color || spread >= 4;
        $(s, '[data-freeze]').disabled = spread < 4 || frozen;
        $(s, '[data-done]').hidden = spread < 4;
        msg.textContent = !color ? 'Elige un ingrediente.' : spread < 4 ? 'Unta con la espátula: ' + spread + '/4 texturas.' : frozen ? 'Congelada: más tiempo para lamer.' : 'Todas las texturas untadas. ¿La congelas un rato?';
      };
      ings.forEach((b) => b.addEventListener('click', () => { color = b.dataset.ing; ings.forEach((x) => x.setAttribute('aria-pressed', String(x === b))); spread = 0; frozen = false; draw(); }));
      $(s, '[data-spread]').addEventListener('click', () => { spread += 1; draw(); });
      $(s, '[data-freeze]').addEventListener('click', () => { frozen = true; draw(); });
      $(s, '[data-reset]').addEventListener('click', () => { color = ''; spread = 0; frozen = false; ings.forEach((x) => x.setAttribute('aria-pressed', 'false')); draw(); });
      draw();
    });

    // 10. Mochila
    document.querySelectorAll('[data-pm-sim="mochila"]:not([data-b])').forEach((s) => {
      s.dataset.b = '1';
      const ICON = ['🦴', '📱', '🔑', '💩'];
      const TXT = ['Los premios van en el compartimento principal, con cierre de cordón.', 'El móvil, en el bolsillo delantero con solapa.', 'Las llaves, en el bolsillo lateral de rejilla.', 'El rollo de bolsas, dentro: salen de una en una por el agujero.'];
      const items = [...s.querySelectorAll('[data-item]')];
      const zones = [...s.querySelectorAll('[data-zone]')];
      items.forEach((b) => b.addEventListener('click', () => {
        const i = Number(b.dataset.item);
        b.setAttribute('aria-pressed', 'true');
        zones[i].classList.add('is-in');
        zones[i].querySelector('i').textContent = ICON[i];
        $(s, '[data-msg]').textContent = TXT[i];
        $(s, '[data-done]').hidden = !items.every((x) => x.getAttribute('aria-pressed') === 'true');
      }));
      $(s, '[data-reset]').addEventListener('click', () => {
        items.forEach((x) => x.setAttribute('aria-pressed', 'false'));
        zones.forEach((z) => { z.classList.remove('is-in'); z.querySelector('i').textContent = ''; });
        $(s, '[data-msg]').textContent = 'Toca una cosa para guardarla.';
        $(s, '[data-done]').hidden = true;
      });
    });

    document.addEventListener('click', buy);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-interactive-simulator"] && !Shopify.designMode) return;
  try {
    (() => {
    const buy = (e) => {
      const b = e.target.closest('[data-buy]');
      if (!b) return;
      e.preventDefault();
      (document.querySelector('[data-pm-buy], product-form, .product-form, .product-details, main form[action*="/cart/add"]') || document.body).scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    // 1. El escudo de calma
    document.querySelectorAll('[data-pm-sim="calma"]:not([data-b])').forEach((s) => {
      s.dataset.b = '1';
      const LV = { petardos: [110, 100, 'Alto (alerta)'], tormenta: [95, 82, 'Alto (alerta)'], trafico: [85, 66, 'Medio'] };
      let key = 'petardos';
      let on = false;
      const db = s.querySelector('[data-db]');
      const bar = s.querySelector('[data-bar]');
      const state = s.querySelector('[data-state]');
      const note = s.querySelector('[data-note]');
      const sw = s.querySelector('[data-switch]');
      const draw = () => {
        const [d, p, st] = LV[key];
        s.classList.toggle('is-calm', on);
        bar.style.width = (on ? p * 0.4 : p) + '%';
        db.textContent = on ? 'Ruido amortiguado' : d + ' dB';
        state.textContent = on ? 'Calma y enfoque olfativo' : 'Nivel de estrés: ' + st;
        note.textContent = on ? 'Modo refugio activado' : '';
        sw.setAttribute('aria-checked', String(on));
      };
      s.querySelectorAll('[data-sc]').forEach((b) => b.addEventListener('click', () => {
        key = b.dataset.sc;
        s.querySelectorAll('[data-sc]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        draw();
      }));
      sw.addEventListener('click', () => { on = !on; draw(); });
      draw();
    });

    // 2. Adiós barro: 6 pasadas del vaso (arrastrando) o del botón = 100 % → 0 %
    document.querySelectorAll('[data-pm-sim="barro"]:not([data-b])').forEach((s) => {
      s.dataset.b = '1';
      const TOTAL = 6;
      let steps = 0;
      const pct = s.querySelector('[data-pct]');
      const done = s.querySelector('[data-done]');
      const spots = [...s.querySelectorAll('[data-spot]')];
      const prints = s.querySelectorAll('[data-print]');
      const cup = s.querySelector('[data-cup]');
      const draw = () => {
        const left = 1 - steps / TOTAL;
        pct.textContent = Math.round(left * 100) + '%';
        spots.forEach((e, i) => { e.style.opacity = i / spots.length < left ? 1 : 0; });
        prints.forEach((e) => { e.style.opacity = left; });
        done.hidden = steps < TOTAL;
        s.classList.toggle('is-clean', steps >= TOTAL);
      };
      const step = () => { if (steps < TOTAL) { steps += 1; draw(); } };
      let y0 = null;
      let last = 0;
      let acc = 0;
      cup.addEventListener('pointerdown', (e) => { cup.setPointerCapture(e.pointerId); y0 = e.clientY; last = e.clientY; acc = 0; });
      cup.addEventListener('pointermove', (e) => {
        if (y0 === null) return;
        acc += Math.abs(e.clientY - last);
        last = e.clientY;
        cup.style.transform = 'translateY(' + Math.max(-50, Math.min(50, e.clientY - y0)) + 'px)';
        if (acc >= 55) { acc = 0; step(); }
      });
      const end = () => { y0 = null; cup.style.transform = ''; };
      cup.addEventListener('pointerup', end);
      cup.addEventListener('pointercancel', end);
      s.querySelector('[data-clean]').addEventListener('click', step);
      s.querySelector('[data-reset]').addEventListener('click', () => { steps = 0; draw(); });
      draw();
    });

    // 3. Esconde y olfatea: 5 pliegues = 5 premios
    document.querySelectorAll('[data-pm-sim="olfato"]:not([data-b])').forEach((s) => {
      s.dataset.b = '1';
      const flaps = [...s.querySelectorAll('[data-flap]')];
      const draw = () => {
        const n = flaps.filter((f) => f.getAttribute('aria-pressed') === 'true').length;
        s.querySelector('[data-nerv]').textContent = (100 - n * 20) + '%';
        s.querySelector('[data-relax]').textContent = (n * 20) + '%';
        s.querySelector('[data-nbar]').style.width = (100 - n * 20) + '%';
        s.querySelector('[data-rbar]').style.width = (n * 20) + '%';
        s.querySelector('[data-hidden]').textContent = n + '/5 premios escondidos';
        s.querySelector('[data-cta]').hidden = n < 5;
      };
      flaps.forEach((f) => f.addEventListener('click', () => { f.setAttribute('aria-pressed', 'true'); draw(); }));
      s.querySelector('[data-reset]').addEventListener('click', () => { flaps.forEach((f) => f.setAttribute('aria-pressed', 'false')); draw(); });
      draw();
    });

    document.addEventListener('click', buy);
  })();
  } catch(e) { console.error(e); }
})();

})();
